<template>
  <div class="function-panel">
    <label class="section-label">函数</label>
<!--    <div class="function-search">-->
<!--      <el-input-->
<!--        placeholder="输入关键字进行过滤"-->
<!--        v-model="searchQuery"-->
<!--        size="small"-->
<!--        clearable-->
<!--      >-->
<!--        <i slot="prefix" class="el-input__icon el-icon-search"></i>-->
<!--      </el-input>-->
<!--    </div>-->

      <div class="function-categories">
        <div
          v-for="category in categories"
          :key="category.name"
          class="category-item"
        >
          <div 
            class="category-header"
            @click="toggleCategory(category.name)"
          >
            <i 
              class="el-icon-arrow-right" 
              :class="{ 'rotate-90': expandedCategories.includes(category.name) }"
            ></i>
            {{ category.name }}
          </div>
          <div 
            v-if="expandedCategories.includes(category.name)"
            class="function-list"
          >
            <div
              v-for="func in category.functions"
              :key="func.name"
              v-show="!searchQuery || isFunctionMatchSearch(func)"
              class="function-item"
              @click="handleFunctionClick(func)"
              @mouseenter="handleFunctionMouseEnter(func)"
            >
              {{ func.name }}
            </div>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
export default {
  name: 'FunctionPanel',
  
  props: {
    categories: {
      type: Array,
      default: () => []
    },
    initialExpandedCategories: {
      type: Array,
      default: () => ['数学函数']
    }
  },
  
  data() {
    return {
      // 函数搜索查询
      searchQuery: '',
      // 展开的函数分类
      expandedCategories: [...this.initialExpandedCategories]
    }
  },
  
  methods: {
    // 切换函数分类展开状态
    toggleCategory(categoryName) {
      const index = this.expandedCategories.indexOf(categoryName)
      if (index > -1) {
        this.expandedCategories.splice(index, 1)
      } else {
        this.expandedCategories.push(categoryName)
      }
    },
    
    // 函数是否匹配搜索查询
    isFunctionMatchSearch(func) {
      return func.name.toLowerCase().includes(this.searchQuery.toLowerCase())
    },
    
    // 函数点击事件处理
    handleFunctionClick(func) {
      this.$emit('select', func.name)
    },
    
    // 函数鼠标悬停事件处理
    handleFunctionMouseEnter(func) {
      this.$emit('hover', func)
    }
  }
}
</script>

<style lang="scss" scoped>
.function-panel {
  .section-label {
    display: block;
    margin-bottom: 8px;
    font-weight: 500;
    color: #333;
  }

  .function-search {
    margin-bottom: 15px;
  }

  .function-categories {
    .category-header {
      display: flex;
      align-items: center;
      padding: 8px 0;
      font-weight: 500;
      cursor: pointer;

      i {
        margin-right: 8px;
        transition: transform 0.2s;

        &.rotate-90 {
          transform: rotate(90deg);
        }
      }
    }

    .function-list {
      padding-left: 20px;
      margin-bottom: 10px;
    }

    .function-item {
      text-align: left;
      padding: 6px 12px;
      cursor: pointer;
      border-radius: 4px;
      transition: background-color 0.2s;

      &:hover {
        background: #e4e7ed;
      }
    }
  }
}
</style>